import { Box, Divider, Paper, Stack, Typography } from "@mui/material"
import NumberFunctions from "../../../../core/functions/NumberFunctions"
import { useMemo, useState } from "react"
import { useCheckoutContext } from "../../../../core/hooks/useCheckoutContext"
import { checkoutPayment7Style } from "./Payment/PaymentConsts"
import CheckoutHeader6 from "./CheckoutHeader"
import ContentDialog from "../../../Dialogs/ContentDialog"
import { red } from "@mui/material/colors"
import DetailProductItem7 from "./DetailProductItem"
import { TSale, TSaleProduct } from "../../../../core/types/Sale"
import OrderItem7 from "./OrderDetails/OrderItem7"
import { IProductPrice } from "../../../../core/types/Product"
import { useFormContext, useWatch } from "react-hook-form"
import CheckoutFunctions from "../../../../core/functions/CheckoutFunctions"

interface CheckoutCoverImage7Props {
  data: IProductPrice | null
  products: TSaleProduct[]
  paymentMethodType: number
  paymentInstallment: number
  paymentTotal: number
  paymentValue: number
}

const CheckoutCoverImage7 = ({
  data,
  products,
  paymentMethodType,
  paymentInstallment,
  paymentTotal,
  paymentValue,
}: CheckoutCoverImage7Props) => {
  const { productPrice, installment } = useCheckoutContext()
  const { control, setValue } = useFormContext<TSale>()

  const quantityValue = useWatch({ control, name: "quantity", defaultValue: 1 })

  const [openDescription, setOpenDescription] = useState(false)

  const values = useMemo(
    () => ({
      people: NumberFunctions.getRandomInt(10) + 4,
      paymentMethodsHtml: productPrice?.paymentMethods.map((pm, index) => {
        let concat = ""
        if (index < productPrice?.paymentMethods.length - 2) concat = ", "
        else if (index === productPrice?.paymentMethods.length - 2)
          concat = " ou "

        return (
          <>
            <b>{checkoutPayment7Style[pm.methodType].label}</b>
            {concat}
          </>
        )
      }),
    }),
    [productPrice?.paymentMethods]
  )

  const value = NumberFunctions.round(
    productPrice?.firstPurchasePrice ?? productPrice?.value ?? 0
  )

  return (
    <>
      <CheckoutHeader6 />
      <Stack
        direction="column"
        spacing={2}
        sx={{ px: { xs: 1, sm: 3 }, pt: 1 }}
      >
        <Typography
          color="#464A5A"
          fontSize={{ xs: "16px", sm: "16px" }}
          lineHeight={{ xs: "20px", sm: "20px" }}
          fontWeight={500}
          style={{ display: "inline-block" }}
        >
          <i className="fa fa-eye" style={{ marginRight: "4px" }}></i>
          Outras {values.people} pessoas estão baixando a cópia do ebook agora.
        </Typography>
      </Stack>

      <Stack
        direction="column"
        sx={{ px: { xs: 2, sm: 3 }, pt: 3 }}
        width="100%"
      >
        <Paper
          elevation={5}
          sx={{
            border: "2px solid #3ebf90",
            borderRadius: "20px",
          }}
        >
          <Stack
            direction="column"
            spacing={1}
            width="100%"
            sx={{ pt: 2, pb: 1 }}
          >
            <Typography fontWeight={500} sx={{ px: 1 }}>
              Resumo do pedido
            </Typography>
            <Paper
              elevation={0}
              sx={{
                p: 1,
                backgroundColor: "#3ebf90",
                borderRadius: "0px",
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
              >
                <Typography
                  color="white"
                  fontSize={{ xs: "16px", sm: "16px" }}
                  lineHeight={{ xs: "20px", sm: "22px" }}
                  fontWeight={600}
                >
                  {"Últimos dias de desconto".toUpperCase()}
                </Typography>
              </Stack>
            </Paper>

            <Box sx={{ height: 10 }} />

            <DetailProductItem7
              productImageUrl={productPrice?.productImageUrl}
              productName={productPrice?.productName}
              value={value}
              quantityValue={quantityValue}
              setQuantity={(next) => setValue("quantity", next)}
              isAllowChooseQuantity={CheckoutFunctions.isAllowsChooseQuantity(
                productPrice
              )}
              isMainProduct
            />

            {products.map((product) => (
              <DetailProductItem7
                productImageUrl={product.productCoverUrl}
                productName={product.productName}
                value={product.value}
                isMainProduct={false}
                isAllowChooseQuantity={false}
                quantityValue={1}
              />
            ))}

            <Divider sx={{ display: { xs: "none", sm: "block" } }} />

            <Box sx={{ height: 6 }} />

            <Box sx={{ pb: 1 }}>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="space-between"
                sx={{ px: 1, pb: 1 }}
              >
                <Typography
                  fontSize="14px"
                  lineHeight="18px"
                  fontWeight={400}
                  color={red[500]}
                >
                  Preço original
                </Typography>
                <Stack
                  direction="column"
                  spacing={0}
                  alignContent="end"
                  alignItems="end"
                >
                  <Typography
                    fontWeight={400}
                    color={red[500]}
                    sx={{
                      fontSize: "14px",
                      lineHeight: "18px",
                      textDecoration: "line-through",
                    }}
                  >
                    {NumberFunctions.formatMoneyDefault(59)}
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="space-between"
                sx={{ px: 1, pb: 1 }}
              >
                <Typography fontSize="15px" lineHeight="22px" fontWeight={600}>
                  Subtotal
                </Typography>
                <Stack
                  direction="column"
                  spacing={0}
                  alignContent="end"
                  alignItems="end"
                >
                  <Typography
                    fontWeight={600}
                    sx={{ fontSize: "15px", lineHeight: "18px" }}
                  >
                    {NumberFunctions.formatMoneyDefault(paymentTotal)}
                  </Typography>
                </Stack>
              </Stack>
              <OrderItem7
                subtitle
                paymentMethodType={paymentMethodType}
                installmentNumber={paymentInstallment}
                description="Total"
                value={paymentTotal}
                defaultValue={paymentValue}
                installments={installment?.checkout}
                typePayment={data?.typePayment}
              />
            </Box>
          </Stack>
        </Paper>
      </Stack>
      <ContentDialog
        open={openDescription}
        title={productPrice?.productName}
        hasCancel={false}
        onClose={() => setOpenDescription(false)}
      >
        {productPrice?.productDescription}
      </ContentDialog>
    </>
  )
}

export default CheckoutCoverImage7
